<template>
  <section>
    <b-field :label="label">
      <b-datepicker
        v-model="computedValue"
        ref="datepicker"
        :placeholder="placeholder"
        :min-date="minDate"
        :max-date="maxDate"
        :focused-date="focusedDate"
        :events="events"
        :mobileNative="false"
        indicators="bars"
        :nearby-selectable-month-days="true"
        :class="`datepickerWithNoArrows ${this.pickerId}`"
        v-on:change-month="checkMonthChange($event, dateIndex)"
        v-on:change-year="checkYearChange($event, dateIndex)"
      >
        <template>
          <div
            class="m-0 has-text-centered"
            v-if="
              flightDates.length > 0 ||
                carDates.length > 0 ||
                hotelDates.length > 0
            "
          >
            <h4 class="is-size-7 has-text-grey mb-3">
              Use Existing Travel Dates
            </h4>
            <div
              class="is-inline-block mr-5 is-clickable box p-2"
              @click="useSegmentDates(flightDates)"
              v-if="flightDates.length > 0 && segmentType != 'flight'"
            >
              <span class="has-background-info dot mr-1"></span>
              <span class="is-inline-block">Flight dates</span>
              <br />
              <span class="has-text-grey is-size-7">{{
                flightDatesDisplay
              }}</span>
            </div>
            <div
              class="is-inline-block mr-5 is-clickable box p-2"
              @click="useSegmentDates(carDates)"
              v-if="carDates.length > 0 && segmentType != 'car'"
            >
              <span class="has-background-success dot mr-1"></span>
              <span class="is-inline-block">Car dates</span>
              <br />
              <span class="has-text-grey is-size-7">{{
                carDatesDisplay
              }}</span>
            </div>
            <div
              class="is-inline-block mr-5 is-clickable box p-2"
              @click="useSegmentDates(hotelDates)"
              v-if="hotelDates.length > 0 && segmentType != 'hotel'"
            >
              <span class="has-background-danger dot mr-1"></span>
              <span class="is-inline-block">
                Hotel dates
              </span>
              <br />
              <span class="has-text-grey is-size-7">{{
                hotelDatesDisplay
              }}</span>
            </div>
          </div>
        </template>
      </b-datepicker>
    </b-field>
  </section>
</template>

<script>
let moment = require("moment");

export default {
  name: "DateSelector",
  props: {
    value: {},
    label: {
      type: String,
      default: "", //keep this empty
    },
    segmentType: String,
    placeholder: {
      type: String,
      default: "Select Date",
    },
    minDate: {
      type: Date,
      default: () => new Date()
    },
    maxDate: {
      type: Date,
      default: null
    },
    focusedDate: {
      type: Date,
      ddefault: () => new Date()
    },
    dateIndex: {
      type: Number,
      default: 0,
    },
    toggleDatepicker: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      prevArrowElements: [],
      nextArrowElements: [],
      currentPickerYear: "",
      prevArrowsDisabled: false,
      nextArrowsDisabled: false,
    };
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    /*    
      minDate() {
      // Look for a date for this segment type that is before this dateIndex
      if (this.localMinDate) {
        if (this.segmentType == "flight") {
          return this.localMinDate;
        }
        return this.localMinDate.addDays(1);
      }
      return this.absoluteMinDate;
    },
    maxDate() {
      return this.absoluteMaxDate;
    },
    absoluteMinDate() {
      let date = this.$date.getFirstTravelDate();
      return moment(date).toDate();
    },
    absoluteMaxDate() {
      let date = this.$date.getLastTravelDate();
      return moment(date).toDate();
    },
    localMinDate() {
      var previousDateIndex = this.dateIndex - 1;
      if (
        this.dateIndex > 0 &&
        this.currentSegmentDates &&
        this.currentSegmentDates[previousDateIndex]
      ) {
        return this.currentSegmentDates[previousDateIndex];
      }

      return null;
    },
    focusedDate() {
      if (this.firstSelectedTravelDate) {
        return moment(this.firstSelectedTravelDate).toDate();
      }

      return this.minDate;
    },
    firstSelectedTravelDate() {
      var firstSelectedTravelDate = this.$store.getters[
        "bookTravel/getFirstSelectedDate"
      ];

      return firstSelectedTravelDate;
    },
    */
    currentSegmentDates() {
      var segmentVariableName = this.segmentType + "DatesSearched";
      var dates = this[segmentVariableName];

      return dates;
    },
    //returns dates of any flights already selected for the current trip
    flightDates() {
      return this.$store.getters["bookTravel/getSelectedFlightDates"];
    },
    flightDatesDisplay() {
      var dates = this.flightDates;

      var displayMessageParts = [];
      var displayMessage = "";

      for (let date of dates) {
        displayMessageParts.push(moment(date).format("MMM D"));
      }

      if (displayMessageParts.length > 2) {
        displayMessage = displayMessageParts.join(", ");
      } else {
        displayMessage = displayMessageParts.join(" - ");
      }

      return displayMessage;
    },
    //returns dates of any car reservations already selected for the current trip
    carDates() {
      return this.$store.getters["bookTravel/getSelectedCarDates"];
    },
    carDatesDisplay() {
      var dates = this.carDates;

      var displayMessageParts = [];

      for (let date of dates) {
        displayMessageParts.push(moment(date).format("MMM D"));
      }

      return displayMessageParts.join(" - ");
    },
    //returns dates of any hotel reservations already selected for the current trip
    hotelDates() {
      return this.$store.getters["bookTravel/getSelectedHotelDates"];
    },
    hotelDatesDisplay() {
      let dates = this.hotelDates;
      let displayMessageParts = [];
      for (let date of dates) {
        displayMessageParts.push(moment(date).format("MMM D"));
      }

      return displayMessageParts.join(" - ");
    },

    events() {
      var allSelectedDates = this.$store.getters[
        "bookTravel/getAllSelectedDates"
      ];

      var filteredSelectedDates = allSelectedDates.filter((singleDate) => {
        return singleDate.segmentType != this.segmentType;
      });

      return filteredSelectedDates;
    },
    minDateElements() {
      let date = {};
      let minDate = moment(this.minDate);

      date.minMonth = minDate.month();
      date.minYear = minDate.year();

      return date;
    },
    maxDateElements() {
      let date = {};
      let maxDate = moment(this.maxDate);

      date.maxMonth = maxDate.month();
      date.maxYear = maxDate.year();

      return date;
    },
    pickerYear() {
      return this.currentPickerYear || this.minDateElements.minYear;
    },
    pickerId() {
      return `dateIndex_${this.dateIndex}`;
    },
  },

  methods: {
    toggle() {
      this.$refs.datepicker.toggle();
      //let id = `datepicker_${this.dateIndex}`;
      //this.$refs[id].toggle();
    },
    // dates = Array(startDate, endDate)
    useSegmentDates(dates) {
     this.$emit('setDateRange', dates);
    },
    checkMonthChange(event = null, dateIndex) {
      // console.log('checkMonthChange', event, dateIndex);

      // only do operations on the arrows if we provide minDate or maxDate
      if (this.minDate !== null || this.maxDate !== null) {
        // explicitly check for null, as month can be returned as ZERO (0) for January ( if(!event) will not work )
        if (event === null) {
          // disable ALL prev arrows by default since we already know the min date
          for (const arrow in this.prevArrowElements) {
            this.disabledMode(this.prevArrowElements[arrow]);
          }
          this.prevArrowsDisabled = true;
          this.nextArrowsDisabled = false;
        } else {
          // console.log('Month change happened', event, this.minDateElements.minMonth, this.maxDateElements.maxMonth, dateIndex);

          // Check if event (month) is equal to our minMonth or maxMonth
          if (
            event == this.minDateElements.minMonth ||
            event == this.maxDateElements.maxMonth
          ) {
            // console.log('you reached min or max month. do a check. ');
            if (
              event <= this.minDateElements.minMonth &&
              this.pickerYear >= this.maxDateElements.maxYear
            ) {
              // disable next arrow
              this.disabledMode(
                this.nextArrowElements[`dateIndex_${dateIndex}`]
              );
              this.nextArrowsDisabled = true;
              // enable prev arrows
              if (this.prevArrowsDisabled) {
                this.enabledMode(
                  this.prevArrowElements[`dateIndex_${dateIndex}`]
                );
                this.prevArrowsDisabled = false;
              }
            }

            if (
              event >= this.maxDateElements.maxMonth &&
              this.pickerYear <= this.minDateElements.minYear
            ) {
              // disable prev arrow
              this.disabledMode(
                this.prevArrowElements[`dateIndex_${dateIndex}`]
              );
              this.prevArrowsDisabled = true;
              // enable next arrow
              if (this.nextArrowsDisabled) {
                this.enabledMode(
                  this.nextArrowElements[`dateIndex_${dateIndex}`]
                );
              }
              this.nextArrowsDisabled = false;
            }
          } else {
            // we have to check if arrows disabled, because for some reason Vue doesn't recognize .disabled attribute and is throwing na error in enabledMode()
            if (this.prevArrowsDisabled) {
              this.enabledMode(
                this.prevArrowElements[`dateIndex_${dateIndex}`]
              );
              this.prevArrowsDisabled = false;
            }
            if (this.nextArrowsDisabled) {
              this.enabledMode(
                this.nextArrowElements[`dateIndex_${dateIndex}`]
              );
              this.nextArrowsDisabled = false;
            }
          }
        }
      }
    },
    disabledMode(node) {
      // console.log('called disabledMode on: ', node);
      node.setAttribute("disabled", true);
      node.classList.add("disabledArrow");
      node.style.pointerEvents = "none";
    },
    enabledMode(node) {
      // console.log('called enabledMode on:', node);
      node.removeAttribute("disabled");
      node.classList.remove("disabledArrow");
      node.style.pointerEvents = "auto";
    },
    checkYearChange(year = null) {
      this.currentPickerYear = year;
      // console.log('Year change happened', year, this.pickerYear);
      // TODO we may need to add a check here in case user selects a year directly from a dropdown
    },
  },

  watch: {
    toggleDatepicker(newVal, prevVal) {
      if (newVal) {
        this.$refs.datepicker_1.toggle();
      }
    },
  },

  mounted() {
    // START Datepicker arrow behavior overwrite
    // get Buefy Datepicker arrow elements when component mounts, so that we can control them on our end
    this.prevArrowElements[
      `dateIndex_${this.dateIndex}`
    ] = document.querySelector(
      ".datepickerWithNoArrows.dateIndex_" +
        this.dateIndex +
        " .pagination-previous"
    );
    this.nextArrowElements[
      `dateIndex_${this.dateIndex}`
    ] = document.querySelector(
      ".datepickerWithNoArrows.dateIndex_" +
        this.dateIndex +
        " .pagination-next"
    );
    // // Call method to check date and disable prev, next arrows if necessary
    this.checkMonthChange(null, this.dateIndex);
    // END Datepicker arrow behavior overwrite
  },
};
</script>

<style scoped>
.dot {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  position: relative;
}
</style>
